import { generate } from "../../helpers/element/generate-element";
import { slideDown } from "../../helpers/utils/slide";

class CalculatorDiningTable {
    constructor() {
        // Discount configuration
        this.discount = {
            percentage: 10, // Discount percentage (e.g., 10 for 10% off)
            startDate: '2026-05-28 00:00:00', // Start date with time
            endDate: '2026-06-07 23:59:59' // End date with time
        };

        this.requiredInputs = [
            'length',
            'width',
            'finish',
            'type',
            'quantity'
        ];

        this.inputGroups = [];
        this.values = [];
        this.costValue;
        this.hasDisplayed = false;
        this.isOversized = false;

        this.defaultVariables = {
            board_value: 4,
            sandingBasicRate: 15,
            finishBasicRate: 20,
            stainBasicRate: 15,
            frame1799Under: 240,
            frame1800Over: 270,
            frameClear: 40,
            taperedLeg: 40,
            jointPpmm: 0.001,
            boardPpmm: 0.005,
            biscuitPpmm: 0.002,
            sandingPparea: 0.008,
            finishingPpArea: 0.00002,
            finishMaterialPpmm: 0.000003,
            stainPparea: 0.000002,
            discountLegs: 100
        };

        if (this.canInit()) {
            this.getInputs();
            this.addEvents();
        }
    }

    canInit() {
        return document.querySelector('.js-calc-form[data-form=dining]') !== null;
    }

    getInputs() {
        const inputGroups = document.querySelectorAll('.js-calc-form .af-field');

        this.inputGroups = [...inputGroups].filter((group) => {
            return this.requiredInputs.includes(group.dataset.name);
        });
    }

    addEvents() {
        const trigger = document.querySelector('.js-calculate.button');

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleClick();
        })
    }

    handleClick() {
        this.getVariableValues();
        if (this.getInputValues()) {
            this.doCalculation();
            this.displayValues();
        }
    }

    getVariableValues() {
        let definedVariables = {};

        if (typeof values_data !== 'undefined' && values_data !== null) {
            definedVariables = values_data;
        }

        this.variables = { ...this.defaultVariables, ...definedVariables };
    }

    getInputValues() {
        let out = true;
        let width, length, lengthGroup;
        let isOversized = false;

        this.inputGroups.forEach((inputGroup) => {
            const name = inputGroup.dataset.name;
            const input = inputGroup.querySelector('input');
            const select = inputGroup.querySelector('select');
            let value;

            let errors = inputGroup.querySelectorAll('.error');
            for (var i = 0; i < errors.length; i++) {
                errors[i].remove();
            }

            if (input !== null) {
                value = input.value;
            }

            if (select !== null) {
                value = select.options[select.selectedIndex].value;
            }

            this.values['_' + name] = value;
            if ((name == 'length' || name == 'width')) {
                if (value > 3900) {
                    out = false;
                    let error = generate('div', name + ' cannot be longer than 3900mm', []);
                    error.classList.add('error');
                    inputGroup.append(error);
                }
                if (value < 500) {
                    out = false;
                    let error = generate('div', name + ' must be longer than 500mm', []);
                    error.classList.add('error');
                    inputGroup.append(error);
                }
                if (value > 2400) {
                    isOversized = true;
                }
                if (name == 'width') {
                    width = parseInt(value);
                } else if (name == 'length') {
                    length = parseInt(value);
                    lengthGroup = inputGroup;
                }
            }
        });

        if (width > length) {
            out = false;
            let error = generate('div', 'length must be longer than width', []);
            error.classList.add('error');
            lengthGroup.append(error);
        }

        this.isOversized = isOversized;
        return out;
    }

    doCalculation() {
        if (this.isOversized) {
            this.costValue = null;
            return;
        }

        const finishType = this.values._finish;
        const isStain = ['indoorLight', 'indoorMedium', 'indoorDark'].includes(finishType);
        const tableType = this.values._type;
        const quantity = parseInt(this.values._quantity, 10);
        const length = parseInt(this.values._length, 10);
        const width = parseInt(this.values._width, 10);

        const boardsCountT7 = width / 100;
        const boardsMMU7 = (width / 200) * length;
        const boardsOW7 = (this.variables.board_value * boardsCountT7) + 10;
        const jointedMMX7 = (boardsCountT7 - 1) * length;

        const jointingCostU10 = this.round((jointedMMX7 * this.variables.jointPpmm) + (boardsCountT7 * 2), 2);
        const biscuitCostX10 = jointedMMX7 * this.variables.biscuitPpmm;

        const glueUpT13 = (boardsCountT7 * 2) + (jointedMMX7 * 0.002);
        const sandingW13 = (this.variables.sandingPparea * (length + width)) + this.variables.sandingBasicRate;
        const woodCostX13 = this.variables.boardPpmm * boardsMMU7;
        
        const areaToFinishW16 = (length * width) * 2;
        const finishingLabourX16 = areaToFinishW16 * this.variables.finishingPpArea;

        const materialCostT19 = areaToFinishW16 * this.variables.finishMaterialPpmm;
        const clearFinishingCostU19 = this.variables.finishBasicRate + materialCostT19 + finishingLabourX16;
        const stainingCostX19 = this.variables.stainBasicRate + (areaToFinishW16 * this.variables.stainPparea);

        const lengthOver1200T22 = (length > 1200) ? length - 1200 : 0;
        const sandedPriceT3 = boardsOW7 + jointingCostU10 + biscuitCostX10 + glueUpT13 + sandingW13 + woodCostX13;
        const priceForLongTopsU22 = (sandedPriceT3 / length) * (lengthOver1200T22 / 3);
        const framePriceSandX22 = (length < 1800) ? this.variables.frame1799Under : this.variables.frame1800Over;
        const clearPriceU3 = sandedPriceT3 + clearFinishingCostU19;
        const stainedPriceV3 = clearPriceU3 + stainingCostX19;
        const frameStainingX28 = Math.ceil((stainingCostX19 / 3), 2);

        const sandedTopTotalT25 = Math.ceil(sandedPriceT3 + priceForLongTopsU22);
        const clearTopTotalU25 = Math.ceil(sandedTopTotalT25 + clearFinishingCostU19);
        const stainedTopTotalV25 = Math.ceil(clearTopTotalU25 + stainingCostX19);

        let price;
        if (tableType === "straightLegFrame") {
            if (isStain) {
                price = stainedTopTotalV25 + framePriceSandX22 - this.variables.discountLegs;
            } else if (finishType === "clear" || finishType === "indoorRawTransparent") {
                price = clearTopTotalU25 + framePriceSandX22 - this.variables.discountLegs;
            } if (finishType === "smooth") {
                price = sandedTopTotalT25 + framePriceSandX22 - this.variables.discountLegs;
            }
        } else if (tableType === "taperedLegFrame") {
            if (isStain) {
                price = stainedTopTotalV25 + framePriceSandX22 + this.variables.frameClear + frameStainingX28 + this.variables.taperedLeg - this.variables.discountLegs;
            } else if (finishType === "clear" || finishType === "indoorRawTransparent") {
                price = clearTopTotalU25 + framePriceSandX22 + this.variables.frameClear + this.variables.taperedLeg - this.variables.discountLegs;
            } if (finishType === "smooth") {
                price = sandedTopTotalT25 + framePriceSandX22 + this.variables.taperedLeg - this.variables.discountLegs;
            }
        } else {
           if (isStain) {
                price = stainedTopTotalV25;
            } else if (finishType === "clear" || finishType === "indoorRawTransparent") {
                price = clearTopTotalU25;
            } else if (finishType === "smooth") {
                price = sandedTopTotalT25;
            }
        }

        const totalPrice = this.round(price * quantity, 0);
        this.costValue = totalPrice.toFixed(2);
    }

    isDiscountActive() {
        const currentDate = new Date();
        const startDate = new Date(this.discount.startDate.replace(' ', 'T'));
        const endDate = new Date(this.discount.endDate.replace(' ', 'T'));
        
        return currentDate >= startDate && currentDate <= endDate;
    }

    displayValues() {
        const container = document.querySelector('.calc-form-sum__calculated');
        const submitButtons = document.querySelector('.af-submit');
        const costArea = document.querySelector('.calc-form-sum__cost');

        if (this.costValue === "NaN" || this.isOversized) {
            container.classList.add('has-error');
            let message;
            
            if (this.isOversized) {
                message = "Your requested dimensions cannot be quoted online. Please continue with your request and one of our team will be in touch with a quote.";
            } else {
                message = "Please enter all values";
            }

            const costElem = generate('span', message, []);
            if (this.isOversized) {
                costElem.classList.add('product-enq-form-oversize-message');
            }
            
            costArea.classList.add('is-hidden');

            setTimeout(() => {
                costArea.innerHTML = '';
                costArea.appendChild(costElem);
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                }, 300);
            }

            if (this.isOversized && !this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(submitButtons, 300, 'flex');
                    this.hasDisplayed = true;
                }, 300);
            } else if (!this.isOversized && this.hasDisplayed) {
                slideUp(submitButtons, 300);
                this.hasDisplayed = false;
            }
        } else {
            let priceHtml;
            if (this.isDiscountActive()) {
                const originalPrice = parseFloat(this.costValue);
                const discountedPrice = this.round(originalPrice * (1 - this.discount.percentage / 100), 2);
                priceHtml = `
                    <div class="price-display">
                        <span class="original-price">£${this.costValue}</span>
                        <span class="discounted-price">£${discountedPrice.toFixed(2)}</span>
                    </div>
                `;
            } else {
                priceHtml = `£${this.costValue}`;
            }

            container.classList.remove('has-error');
            costArea.classList.add('is-hidden');

            setTimeout(() => {
                costArea.innerHTML = priceHtml;
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(submitButtons, 300, 'flex');
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                    this.hasDisplayed = true;
                }, 300);
            }
        }
    }

    round(num, decimals) {
        return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
    }
}

export const calculatorDiningTable = () => {
    new CalculatorDiningTable(); // eslint-disable-line no-new
};
